import { render } from "./coach-detail.vue?vue&type=template&id=7d86bdf4"
import script from "./coach-detail.vue?vue&type=script&lang=js"
export * from "./coach-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__